export default "__VITE_ASSET__Bq$qynPg__"